var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "import-panel" },
    [
      _c("div", { staticClass: "import-left" }, [
        _c(
          "div",
          { staticClass: "method-title" },
          [
            _c(
              "el-tooltip",
              {
                attrs: {
                  content: _vm.$t("QuotationCenter.components.excelImportTip"),
                  placement: "top-start",
                },
              },
              [_c("span", [_vm._v("!")])]
            ),
            _vm._v(
              " " +
                _vm._s(_vm.$t("QuotationCenter.components.excelImportMethod")) +
                " "
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "upload-actions" },
          [
            _c(
              "el-button",
              {
                staticClass: "template-btn",
                attrs: { icon: "el-icon-download" },
                on: { click: _vm.handleDownloadTemplate },
              },
              [
                _vm._v(
                  _vm._s(_vm.$t("QuotationCenter.components.importTemplate"))
                ),
              ]
            ),
            _c(
              "el-button",
              {
                staticClass: "upload-btn-inline",
                attrs: { type: "primary", icon: "el-icon-upload2" },
                on: { click: _vm.openImportDialog },
              },
              [_vm._v(_vm._s(_vm.$t("QuotationCenter.components.clickUpload")))]
            ),
            _c("div", { staticClass: "upload-tip" }, [
              _c("span", [
                _vm._v(
                  _vm._s(_vm.$t("QuotationCenter.components.onlySupportExcel"))
                ),
              ]),
            ]),
          ],
          1
        ),
      ]),
      _c(
        "div",
        { staticClass: "sample-box" },
        [
          _c(
            "h4",
            [
              _vm._v(
                " " +
                  _vm._s(_vm.$t("QuotationCenter.components.priceSample")) +
                  " "
              ),
              _c(
                "el-tooltip",
                {
                  attrs: {
                    content: _vm.$t("QuotationCenter.components.sampleData"),
                    placement: "top",
                  },
                },
                [_c("i", { staticClass: "el-icon-question" })]
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              ref: "sampleTable",
              staticClass: "sample-table",
              attrs: { data: _vm.sampleRows, border: "", size: "mini" },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "index",
                  label: _vm.$t("QuotationCenter.serialNumber"),
                  align: "center",
                  width: "70",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "parcelType",
                  label: _vm.$t("QuotationCenter.packageType"),
                  align: "center",
                  "min-width": "110",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "zone",
                  label: _vm.$t("QuotationCenter.zone"),
                  align: "center",
                  width: "80",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "startWeight",
                  label: _vm.$t("QuotationCenter.start"),
                  align: "center",
                  width: "80",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "endWeight",
                  label: _vm.$t("QuotationCenter.end"),
                  align: "center",
                  width: "80",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "calcType",
                  label: _vm.$t("QuotationCenter.calcMethod"),
                  align: "center",
                  "min-width": "150",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "unitWeight",
                  label: _vm.$t("QuotationCenter.components.roundingUnit"),
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "price",
                  label: _vm.$t("QuotationCenter.components.unitPrice"),
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(_vm._s(_vm.$number2money(scope.row.price, 4))),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "minimumCharge",
                  label: _vm.$t("QuotationCenter.components.minimumCharge"),
                  align: "center",
                  "min-width": "110",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.$number2money(scope.row.minimumCharge))
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("QuotationImportDialog", {
        attrs: { visible: _vm.importDialogVisible, loading: _vm.loading },
        on: {
          "update:visible": function ($event) {
            _vm.importDialogVisible = $event
          },
          closed: _vm.handleDialogClosed,
          confirm: function ($event) {
            return _vm.$emit("confirm", $event)
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }